import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
export function TruthSection() {
  return <SectionWrapper data-id="element-444">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-10" variants={childVariants} data-id="element-445">
        Here's the truth{' '}
        <span className="text-cream-muted" data-id="element-446">(and it's oddly relieving):</span>
      </motion.h2>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-6" variants={childVariants} data-id="element-447">
        Waking up at night is normal.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-448">
        What's not normal is the escalation, the chain reaction that turns a
        wake-up into a full-blown night.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-449">
        That's why "more melatonin" doesn't fix it.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-450">
        That's why "try meditation" sometimes makes you feel <em data-id="element-451">worse</em>{' '}
        (because your brain is too activated to float).
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-12" variants={childVariants} data-id="element-452">
        That's why scrolling "to relax" is a trap (because novelty + light tells
        your brain to start the day).
      </motion.p>

      {/* Pull Quote */}
      <motion.blockquote className="text-center py-4 my-4 border-t border-b border-teal/20" variants={childVariants} data-id="element-453">
        <p className="font-heading text-2xl md:text-3xl text-teal-light font-semibold leading-snug" data-id="element-454">
          You don't need more ideas.
        </p>
        <p className="font-heading text-2xl md:text-3xl text-teal-light font-semibold leading-snug mt-2" data-id="element-455">
          You need fewer choices.
        </p>
      </motion.blockquote>
    </SectionWrapper>;
}